import { useState } from 'react';
import CustomModal from './CustomModal';
import { useAuth } from 'react-oidc-context';
import { NonScriptPackingSlipModalProps } from '../interface/interface';
import { openPackingSlip } from '../helpers/openPackingSlip';

const NonScriptPackingSlipModal = (props: NonScriptPackingSlipModalProps) => {
  const { user } = useAuth();
  const [isGenerating, setIsGenerating] = useState<boolean>(false);

  const handleViewSlip = async () => {
    if (!user?.access_token || !props.orderId) return;
    setIsGenerating(true);
    await openPackingSlip(user.access_token, props.orderId);
    setIsGenerating(false);
  };

  return (
    <CustomModal
      isOpen={props.isOpen}
      onClose={props.onClose}
      header="Packing Slip"
      modalSize="w-2/5"
      footer={
        <>
          <button
            className="mr-4 bg-white border border-solid border-primary-blue-500 text-primary-blue-500 px-4 py-2 rounded flex items-center"
            onClick={handleViewSlip}
            disabled={isGenerating}
          >
            View / Download Slip
          </button>
          <button
            className={`mr-4 bg-primary-blue-500 text-white px-4 py-2 rounded`}
            onClick={props.onConfirm}
          >
            Continue
          </button>
          <button
            className="bg-white border border-solid border-primary-blue-500 text-primary-blue-500 w-24 px-4 py-2 rounded"
            onClick={props.onClose}
          >
            Cancel
          </button>
        </>
      }
    >
      <p>
        This order contains shop products. Please view and print the packing
        slip before moving the order to Dispensed.
      </p>
      <ul className="mt-4 border rounded-md divide-y text-sm">
        {props.products.map((item) => (
          <li key={item.id} className="flex justify-between p-2">
            <span>{item.product?.name}</span>
            <span className="font-semibold text-primary-blue-500 ml-4">
              Qty: {item.orderedQty}
            </span>
          </li>
        ))}
      </ul>
    </CustomModal>
  );
};

export default NonScriptPackingSlipModal;
